import {FC} from 'react'
import {push} from 'connected-react-router'
import {useDispatch} from 'react-redux'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {asyncError} from 'store/actions/asyncError'
import {useStartProcedureStatus, useUpdateProcedureStatus} from 'hooks/api/procedureStatuses'
import Button from 'jbc-front/components/Button'
import {EmployeeName} from '../../parts/EmployeeName'
import {Form} from '../Form'
import {schema} from '../Form/schema'
import {Employee, CREATE_PROCEDURE_CHANGE_OFFICE_DATUM, ChangeOfficeFormSchema} from './query'

// @ts-ignore
import {useMutation} from 'components/Graphql'

interface PresenterProps {
  employee: Employee
}

export const Presenter: FC<PresenterProps> = ({employee}) => {
  const dispatch = useDispatch()
  const methods = useForm<ChangeOfficeFormSchema>({
    resolver: yupResolver(schema),
    reValidateMode: 'onBlur',
    defaultValues: {
      procedureStatusId: undefined,
      beforeOfficeId: employee.personnelHistory?.officeId || employee.currentOffice.id,
      afterOfficeId: undefined,
      relocateOn: '',
    },
  })
  const {handleSubmit, setValue, setError} = methods
  const startProcedureStatus = useStartProcedureStatus()
  const updateProcedureStatus = useUpdateProcedureStatus()
  const [createProcedureChangeOffice] = useMutation(CREATE_PROCEDURE_CHANGE_OFFICE_DATUM)

  const onSubmit = async (data: ChangeOfficeFormSchema) => {
    try {
      let procedureStatusId = data.procedureStatusId
      if (!procedureStatusId) {
        const {
          data: {id},
        } = await startProcedureStatus(employee.id, 'change_office', data.relocateOn)
        procedureStatusId = id
        setValue('procedureStatusId', id)
      } else {
        await updateProcedureStatus(procedureStatusId, data.relocateOn)
      }
      await createProcedureChangeOffice({
        variables: {
          input: {
            procedureStatusId,
            beforeOfficeId: data.beforeOfficeId,
            afterOfficeId: data.afterOfficeId,
            relocateOn: data.relocateOn,
          },
        },
      })

      dispatch(push(`/change_office/flow/${procedureStatusId}`))
    } catch (err) {
      if (err.errors?.afterOfficeId) {
        setError('afterOfficeId', {type: 'custom', message: err.errors.afterOfficeId})
      } else if (err.response && err.response.status === 422) {
        const dateOnError = err.response.data._errors?._base?.date_on
        dateOnError && setError('relocateOn', {type: 'custom', message: dateOnError[0]})
      } else {
        dispatch(asyncError(err))
      }
    }
  }

  return (
    <>
      <div className="l-title-wrap">
        <h1 className="m-title-main">転勤情報</h1>
        <EmployeeName employee={employee} />
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormProvider {...methods}>
          <Form />
        </FormProvider>

        <div className="u-ta-c u-mt30">
          <Button primary onClick={handleSubmit(onSubmit)}>
            次へ
          </Button>
        </div>
      </form>
    </>
  )
}
